import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase'

const SettingsLogout = ({
  color = 'icon.primary',
  fill = 'transparent',
  strokeWidth = '1.3',
  ...props
}) => (
  <IconBase viewBox='0 0 20 20' {...props}>
    <Path
      d='M10.5625 12.7969L7.65787 10.0195L10.5625 7.24203'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <Path
      d='M7.649 10.0139L17.1597 10.0139C17.8828 10.0144 18.4687
         10.5751 18.4687 11.2665V11.2665C18.4685 13.0082 17.7468
         14.6789 16.4616 15.9132V15.9132C14.7303 17.5714 12.3796
         18.5021 9.92913 18.4999C5.53594 18.5171 1.78817 15.4636
         1.10859 11.3134C0.429002 7.16309 3.02136 3.1604 7.20982
         1.89282C11.3983 0.625252 15.927 2.47285 17.8685 6.24124'
      stroke={color}
      fill={fill}
      strokeWidth={strokeWidth}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </IconBase>
)

SettingsLogout.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default SettingsLogout
